import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const hideDomainFolders = isFeature('hide-domain-folders') || false;
